import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import { Modals } from './types'

export type Modal = {
  // whether the modal is open or not will be determined by if there is a type present to display
  type: Modals | null
  loading: boolean
  props?:
    | {
        // rename group modal
        groupId: string
        id?: never
      }
    | {
        // session delete modal
        groupId: string
        id: string
        setSelectedGroupOnCreation?: never
      }
    | {
        // create group modal
        groupId?: never
        id?: never
        setSelectedGroupOnCreation: (groupId: string) => void
      }
}

const initialState: Modal = { type: null, loading: false }

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setType: (
      state,
      {
        payload: { type, props },
      }: PayloadAction<{ type: Modal['type']; props?: Modal['props'] }>
    ) => {
      state.type = type
      state.props = props
    },
    setModalLoading: (state, { payload }: PayloadAction<Modal['loading']>) => {
      state.loading = payload
    },
  },
})

export const { setType } = modalSlice.actions
export const { setModalLoading } = modalSlice.actions
export const selectType = (state: RootState) => state.modal.type
export const selectModalLoading = (state: RootState) => state.modal.loading
export const selectModalProps = (state: RootState) => state.modal.props

export default modalSlice
